import { Component, Inject, Input, OnInit } from '@angular/core';
import { CellEditingStoppedEvent, ColDef, GridApi, GridReadyEvent, RowClassParams, ValueFormatterParams } from '@ag-grid-community/core';
import { ButtonRendererComponent } from './button-renderer';
import { PropertiesRendererComponent } from './properties-renderer';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
    selector: 'properties-value-view',
    templateUrl: './properties-value-view.component.html',
    styleUrls: ['./properties-value-view.component.scss'],
    standalone: false
})
export class PropertiesValueViewComponent implements OnInit {

  constructor(public ThemeService:ThemeService, public ls:LanguageServices) { }

  @Input()options = [];
  rowData:any[] = [];
  inputRow: {} = {};
  pinnedTopRowData = [this.inputRow];
  gridApi:GridApi;
  consOptions:Object[];
  columnDefs: ColDef[] = [];
  
    
  defaultColDef: ColDef = {
    editable: false,
    valueFormatter: (params: ValueFormatterParams): any =>
      this.isEmptyPinnedCell(params)
        ? this.createPinnedCellPlaceholder(params)
        : undefined,
  };

  deleteLine(valor){
      let indexData = this.rowData.findIndex(d=>d.key==valor.data.key);
      if ( indexData > -1 ){
        this.rowData.splice(indexData,1);
      }
      let index = this.options.findIndex(d=>d.value == valor.data.key);
      if ( index == -1 ){
        this.options.push(this.consOptions.find(d=>d['value']==valor.data.key));
        this.options.sort((a,b)=>{
            if ( a.value > b.value) return 1;
            if ( a.value < b.value) return -1;
            return 0;
        });
      } 
      
      const res = this.gridApi.applyTransaction({ remove: [valor.data] })!;
      
  }

   getRowStyle = ({ node }: RowClassParams) =>
    node.rowPinned ? { fontWeight: 'bold', fontStyle: 'italic' } : {};

    onCellEditingStopped(params: CellEditingStoppedEvent) {
      if (this.isPinnedRowDataCompleted(params)) {
        // save data
        
        let index = this.options.findIndex(d=>d.value == this.inputRow['key']);
        this.options.splice(index,1);

        this.rowData = [...this.rowData, this.inputRow];
        //reset pinned row
        this.inputRow = {};
        this.pinnedTopRowData = [this.inputRow];
      }
    }

    private isEmptyPinnedCell({ node, value }: ValueFormatterParams): boolean {
      return (
        (node.rowPinned === 'top' && value == null) ||
        (node.rowPinned === 'top' && value === '')
      );
    }

    private createPinnedCellPlaceholder({
      colDef,
    }: ValueFormatterParams): string {
      if ( colDef.field ==  'action'){
        return null;
      }
      return colDef.headerName[0].toUpperCase() + colDef.headerName.slice(1) + '...';
    }
  
    private isPinnedRowDataCompleted({ rowPinned }): boolean {
      if (rowPinned !== 'top') return;
      return this.columnDefs.filter(d=>d.field !='action').every((def) => this.inputRow[def.field]);
    }

  ngOnInit(): void {
      
      this.options.sort((a,b)=>{
        if ( a.value > b.value) return 1;
        if ( a.value < b.value) return -1;
        return 0;
      });
      this.consOptions = JSON.parse(JSON.stringify(this.options));

      this.columnDefs = [{ 
        editable: (params) =>params.node.isRowPinned()? true: false,
        field: 'key',
        headerName: 'Parâmetro',
        valueFormatter:(param)=>{
          if ( !param.node.isRowPinned()){
            return this.consOptions.find(d=>d['value']==param.value)['name'];
          }else{
             if ( param.value=='' || param.value==null){
               return param.colDef.headerName[0].toUpperCase() + param.colDef.headerName.slice(1) + '...';
             } 
          }
        },
        tooltipValueGetter:(param)=>{
            if ( !param.node.isRowPinned()){
                return this.consOptions.find(d=>d['value']==param.value)['name'];
            }
        },
        cellEditorSelector:(param)=>{
            return { component:PropertiesRendererComponent, params:{options:this.options}}
        },
        flex:1
      },
      {
        field: 'value',
        headerName: 'Valor',
        editable: true,
        flex:2
      },
      {
        field: 'action',
        headerName: 'Ação',
        editable: false,
        width:80,
        cellRendererSelector: (params) => {
            if ( !params.node.isRowPinned() ){
                return {component: ButtonRendererComponent};
            }else{
              return null;
            }
        },
        cellRendererParams: {
          clicked: (field: any) => {
            this.deleteLine(field);
          }
        },
        
      }
  
    ];
      
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    //return this.rowData;
  }

}
